var checkText = (rule, value, callback) => {
    if (value === '') {
        callback(new Error(Loc.g('Veuillez renseigner une valeur')));
    }
    callback();
};

var checkNumber = (rule, value, callback) => {
    if (value === '') {
        callback(new Error(Loc.g('Veuillez renseigner un nombre')));
    }
    callback();
};

var checkIsPercentage = (rule, value, callback) => {
    if (parseInt(value) > 100 || parseInt(value) < 0) {
        callback(new Error(Loc.g('Veuillez renseigner une valeur entre 0 et 100')));
    }
    callback();
};

var checkEmail = (rule, value, callback) => {
    var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
    if (!re.test(String(value).toLowerCase())) {
        callback(new Error(Loc.g('Veuillez renseigner une adresse email valide')));
    }
    callback();
};

/**
 * Validates that a value is not blank meaning
 * - not equal to false or null
 * - not equal to a blank string,
 * - not equal to a blank array,
 */
const checkNotBlank = (rule, value, callback) => {
    const isBlank =
        !value || // false or null
        (typeof value === 'string' && !value.trim()) || // blank string
        (Array.isArray(value) && !value.length); // blank array

    isBlank ? callback(new Error(window.i18n.__('Veuillez saisir une valeur'))) : callback();
};

/**
 * Validates that a value is true. Specifically, this checks if
 * - the value is exactly true
 * - exactly the integer 1
 * - exactly the string '1'
 */
const checkIsTrue = (rule, value, callback) => {
    const isTrue = value === true || value === 1 || value === '1';

    !isTrue ? callback(new Error(window.i18n.__('Cette valeur doit être vrai'))) : callback();
};

/**
 * Validates that a value is not a sellsy mail
 */
const checkedNotSellsyMail = (rule, value, callback) => {
    const isSellsyEmail = !!value.match('@sellsy.com');

    isSellsyEmail
        ? callback(new Error(window.i18n.__('Veuillez saisir une adresse email valide')))
        : callback();
};

/**
 * Validates that a value is a valid password, this checks if
 * - value has min 8 character
 * - value has at least 1 digit
 * - value has at least 1 lowercase
 * - value has at least 1 uppercase
 *
 * This validator can be used with PasswordInput.vue
 */
const checkIsValidPassword = (rule, value, callback) => {
    const hasMinLength = !!value && value.length >= minLengthPassword();
    const hasMaxLength = !!value && value.length <= maxLengthPassword();
    const hasNumber = /\d/.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasUppercase = /[A-Z]/.test(value);

    const isValidPassword =
        hasMinLength && hasMaxLength && hasNumber && hasLowercase && hasUppercase;

    !isValidPassword
        ? callback(new Error(window.i18n.__('Veuillez saisir un mot de passe valide')))
        : callback();
};

/**
 * Validates that a value contain no number
 */
const checkContainNoNumber = (rule, value, callback) => {
    const containNumber = !!value.match(/\d/);
    containNumber
        ? callback(new Error(window.i18n.__('La valeur ne doit pas contenir de chiffre')))
        : callback();
};

const checkContainOnlyNumber = (rule, value, callback) => {
    const containOnlyNumber = /^[0-9,.]+$/.test(value);
    containOnlyNumber
        ? callback()
        : callback(new Error(window.i18n.__('La valeur doit contenir seulement des chiffres')));
};

var checkNotNull = (rule, value, callback) => {
    if (value === null) {
        callback(new Error(Loc.g('Veuillez renseigner une valeur')));
    }
    callback();
};

var checkNotNullLicense = (rule, value, callback) => {
    if (value[0].id === null) {
        callback(new Error(Loc.g('Ce champ est requis')));
    }
    callback();
};

const minLengthPassword = () => {
    return window.App.constraintsValidator.password.minLength;
};

const maxLengthPassword = () => {
    return window.App.constraintsValidator.password.maxLength;
};

export {
    checkText,
    checkNumber,
    checkEmail,
    checkNotBlank,
    checkIsTrue,
    checkedNotSellsyMail,
    checkIsValidPassword,
    checkContainNoNumber,
    checkNotNull,
    checkNotNullLicense,
    checkContainOnlyNumber,
    checkIsPercentage,
    minLengthPassword,
    maxLengthPassword,
};
